import Link from "next/link";

import { useSelector } from "react-redux";

import User from "../Offcanvas/User";
import { useAppContext } from "@/context/Context";

const HeaderRightTwo = ({}) => {
  const { mobile, setMobile } = useAppContext();

  const { total_items } = useSelector((state) => state.CartReducer);

  return (
    <div className="mobile-menu-bar d-block d-xl-none">
      <div className="hamberger">
        <button
          className="hamberger-button rbt-round-btn"
          onClick={() => setMobile(!mobile)}
        >
          <i className="feather-menu"></i>
        </button>
      </div>
    </div>
  );
};

export default HeaderRightTwo;
